interface RawJSONDisplayProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data: any;
}

export const RawJSONDisplay = ({ data }: RawJSONDisplayProps) => {
  const jsonString = JSON.stringify(data, null, 2);

  return (
    <div className="rounded-md bg-gray-50 p-3">
      <pre className="whitespace-pre-wrap break-words font-mono text-xs text-gray-800">
        <code>{jsonString}</code>
      </pre>
    </div>
  );
};
